import React, { useState } from "react";
import { Link } from "react-router-dom";
import config from "../config";
import { Modal } from "react-bootstrap";

const OrderBtn = ({ text, url }) => {
  const [showPopup, setrShowPopup] = useState(false);
  // console.log("url", url)
  return (
    <>
      <div className="order-online">
        <Link className="hero-anchor blue-btn" to={`${config.appUrl}${url}`}>
          <div className="order-online-trans-1"></div>
          <div className="order-online-trans-2"></div>
          {text}
        </Link>
      </div>
    </>
  );
};

export default OrderBtn;
